module.exports = __webpack_public_path__ + "static/media/add-new-card-master.015a0616.svg";